import { call, put, take } from 'redux-saga/effects'
import api from '../api/api'
import supervisorsSchema from '../schemas/supervisors'
import studentsSchema from '../schemas/students'
import { normalize } from 'normalizr'
import { statusCodeIsBelow400, appendToFormData } from '../helpers/utility'

import {
  FETCH_SUPERVISORS_LIST_REQUEST,
  FETCH_SUPERVISORS_LIST_SUCCESS,
  FETCH_SUPERVISORS_LIST_FAIL,
  FETCH_SUPERVISORS_LIST_ASYNC_START,
  FETCH_SUPERVISORS_LIST_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_SUPERVISOR_STUDENTS_REQUEST,
  FETCH_SUPERVISOR_STUDENTS_SUCCESS,
  FETCH_SUPERVISOR_STUDENTS_FAIL,
  FETCH_SUPERVISOR_STUDENTS_ASYNC_START,
  FETCH_SUPERVISOR_STUDENTS_ASYNC_END,
} from '../actions/actions'

import {
  REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_END,
  REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_START,
  REMOVE_STUDENT_FROM_SUPERVISOR_REQUEST,
  REMOVE_STUDENT_FROM_SUPERVISOR_SUCCESS,
  REMOVE_STUDENT_FROM_SUPERVISOR_FAIL,
} from '../actions/actions'

import {
  FETCH_SUPERVISOR_EVENTS_REQUEST,
  FETCH_SUPERVISOR_EVENTS_SUCCESS,
  FETCH_SUPERVISOR_EVENTS_FAILURE,
} from '../actions/actions'

import {
  FETCH_SUPERVISOR_EVENT_HOSTS_REQUEST,
  FETCH_SUPERVISOR_EVENT_HOSTS_SUCCESS,
  FETCH_SUPERVISOR_EVENT_HOSTS_FAILURE,
} from '../actions/actions'

import {
  FETCH_SUPERVISOR_EVENT_SCHOOLS_REQUEST,
  FETCH_SUPERVISOR_EVENT_SCHOOLS_SUCCESS,
  FETCH_SUPERVISOR_EVENT_SCHOOLS_FAILURE,
} from '../actions/actions'

import {
  FETCH_SUPERVISOR_EVENT_STUDENTS_REQUEST,
  FETCH_SUPERVISOR_EVENT_STUDENTS_SUCCESS,
  FETCH_SUPERVISOR_EVENT_STUDENTS_FAILURE,
} from '../actions/actions'

import {
  FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_REQUEST,
  FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_SUCCESS,
  FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_FAILURE,
} from '../actions/actions'

import {
  FETCH_SUPERVISOR_HOST_REQUEST,
  FETCH_SUPERVISOR_HOST_SUCCESS,
  FETCH_SUPERVISOR_HOST_FAILURE,
} from '../actions/actions'

import {
  SUPERVISOR_ADD_HOST_REQUEST,
  SUPERVISOR_ADD_HOST_SUCCESS,
  SUPERVISOR_ADD_HOST_FAILURE,
} from '../actions/actions'

import {
  SUPERVISOR_REMOVE_HOST_REQUEST,
  SUPERVISOR_REMOVE_HOST_SUCCESS,
  SUPERVISOR_REMOVE_HOST_FAILURE,
} from '../actions/actions'

import {
  EDIT_SUPERVISOR_HOST_REQUEST,
  EDIT_SUPERVISOR_HOST_SUCCESS,
  EDIT_SUPERVISOR_HOST_FAILURE,
} from '../actions/actions'

import {
  ADD_STUDENTS_TO_SUPERVISOR_HOST_REQUEST,
  ADD_STUDENTS_TO_SUPERVISOR_HOST_SUCCESS,
  ADD_STUDENTS_TO_SUPERVISOR_HOST_FAILURE,
} from '../actions/actions'

import {
  REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_REQUEST,
  REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_SUCCESS,
  REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_FAILURE,
} from '../actions/actions'

import {
  SUPERVISOR_FETCH_PROMO_CODES_REQUEST,
  SUPERVISOR_FETCH_PROMO_CODES_SUCCESS,
  SUPERVISOR_FETCH_PROMO_CODES_FAILURE,
} from  '../actions/actions'

import {
  FETCH_SINGLE_PROMO_CODE_REQUEST,
  FETCH_SINGLE_PROMO_CODE_SUCCESS,
  FETCH_SINGLE_PROMO_CODE_FAILURE,
} from  '../actions/actions'

import {
  SUPERVISOR_ADD_PROMO_CODE_REQUEST,
  SUPERVISOR_ADD_PROMO_CODE_SUCCESS,
  SUPERVISOR_ADD_PROMO_CODE_FAILURE,
} from  '../actions/actions'

import {
  SUPERVISOR_UPDATE_PROMO_CODE_REQUEST,
  SUPERVISOR_UPDATE_PROMO_CODE_SUCCESS,
  SUPERVISOR_UPDATE_PROMO_CODE_FAILURE,
} from  '../actions/actions'

import {
  SUPERVISOR_FETCH_EVENT_DOCUMENTS_REQUEST,
  SUPERVISOR_FETCH_EVENT_DOCUMENTS_SUCCESS,
  SUPERVISOR_FETCH_EVENT_DOCUMENTS_FAILURE,
} from '../actions/actions'

import {
  SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_REQUEST,
  SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_SUCCESS,
  SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_FAILURE,
} from '../actions/actions'

export function* getSupervisorsList() {
  while (true) {
    const { queryString } = yield take(FETCH_SUPERVISORS_LIST_REQUEST)
    yield put({ type: FETCH_SUPERVISORS_LIST_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(api.getSupervisorsList, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISORS_LIST_SUCCESS,
          supervisors: normalize(data.supervisors, supervisorsSchema),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_SUPERVISORS_LIST_FAIL, error: general_errors })
      }

      yield put({ type: FETCH_SUPERVISORS_LIST_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_SUPERVISORS_LIST_ASYNC_END })
      yield put({ type: FETCH_SUPERVISORS_LIST_FAIL, error })
    }
  }
}

export function* getStudentsOfSupervisor() {
  while (true) {
    const { supervisorId } = yield take(FETCH_SUPERVISOR_STUDENTS_REQUEST)
    yield put({ type: FETCH_SUPERVISOR_STUDENTS_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(api.fetchListOfStudentsOfSupervisor, supervisorId)
      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISOR_STUDENTS_SUCCESS,
          students: normalize(data.students, studentsSchema),
        })
      } else {
        yield put({
          type: FETCH_SUPERVISOR_STUDENTS_FAIL,
          error: general_errors,
        })
      }

      yield put({ type: FETCH_SUPERVISOR_STUDENTS_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_SUPERVISOR_STUDENTS_ASYNC_END })
      yield put({ type: FETCH_SUPERVISOR_STUDENTS_FAIL, error })
    }
  }
}

export function* removeStudentFromSupervisor() {
  while (true) {
    const { supervisorId, studentId } = yield take(REMOVE_STUDENT_FROM_SUPERVISOR_REQUEST)
    yield put({ type: REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_START })
    let formData = appendToFormData({ students: studentId })

    try {
      const {
        data: {
          status,
          errors: { general_errors },
        },
      } = yield call(api.removeStudentFormSupervisor, supervisorId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: REMOVE_STUDENT_FROM_SUPERVISOR_SUCCESS,
          studentId,
        })
      } else {
        yield put({
          type: REMOVE_STUDENT_FROM_SUPERVISOR_FAIL,
          error: general_errors,
        })
      }

      yield put({ type: REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_END })
      yield put({ type: REMOVE_STUDENT_FROM_SUPERVISOR_FAIL, error })
    }
  }
}

export function* fetchSupervisorEvents() {
  while (true) {
    yield take(FETCH_SUPERVISOR_EVENTS_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.fetchSupervisorEvents)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISOR_EVENTS_SUCCESS,
          data,
        })
      } else {
        yield put({
          type: FETCH_SUPERVISOR_EVENTS_FAILURE,
          error: general_errors,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SUPERVISOR_EVENTS_FAILURE,
        error,
      })
    }
  }
}

export function* fetchSupervisorEventStudents() {
  while (true) {
    const {
      eventId,
      queryString = '',
    } = yield take(FETCH_SUPERVISOR_EVENT_STUDENTS_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.fetchSupervisorEventStudents, eventId, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISOR_EVENT_STUDENTS_SUCCESS,
          data,
          queryString,
        })
      } else {
        yield put({
          type: FETCH_SUPERVISOR_EVENT_STUDENTS_FAILURE,
          error: general_errors,
          queryString,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SUPERVISOR_EVENT_STUDENTS_FAILURE,
        error,
        queryString,
      })
    }
  }
}

export function* fetchSupervisorEventHosts() {
  while (true) {
    const {
      eventId
    } = yield take(FETCH_SUPERVISOR_EVENT_HOSTS_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.fetchSupervisorEventHosts, eventId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISOR_EVENT_HOSTS_SUCCESS,
          data,
        })
      } else {
        yield put({
          type: FETCH_SUPERVISOR_EVENT_HOSTS_FAILURE,
          error: general_errors,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SUPERVISOR_EVENT_HOSTS_FAILURE,
        error,
      })
    }
  }
}

export function* fetchSupervisorEventSchools() {
  while (true) {
    const {
      eventId,
      queryString = '',
    } = yield take(FETCH_SUPERVISOR_EVENT_SCHOOLS_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.fetchSupervisorEventSchools, eventId, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISOR_EVENT_SCHOOLS_SUCCESS,
          data,
          queryString,
        })
      } else {
        yield put({
          type: FETCH_SUPERVISOR_EVENT_SCHOOLS_FAILURE,
          error: general_errors,
          queryString,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SUPERVISOR_EVENT_SCHOOLS_FAILURE,
        error,
        queryString,
      })
    }
  }
}

export function* fetchSupervisorSchoolEventStudents() {
  while (true) {
    const {
      eventId,
      schoolId
    } = yield take(FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.fetchSupervisorSchoolEventStudents, eventId, schoolId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_SUCCESS,
          data,
        })
      } else {
        yield put({
          type: FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_FAILURE,
          error: general_errors,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_FAILURE,
        error,
      })
    }
  }
}

export function* fetchSupervisorHost() {
  while (true) {
    const {
      hostId
    } = yield take(FETCH_SUPERVISOR_HOST_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.fetchSupervisorHost, hostId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SUPERVISOR_HOST_SUCCESS,
          data,
        })
      } else {
        yield put({
          type: FETCH_SUPERVISOR_HOST_FAILURE,
          error: general_errors,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SUPERVISOR_HOST_FAILURE,
        error,
      })
    }
  }
}

export function* supervisorAddHost() {
  while (true) {
    const { resolve, reject, eventId, formData } = yield take(SUPERVISOR_ADD_HOST_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.supervisorAddHost, eventId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SUPERVISOR_ADD_HOST_SUCCESS,
          host: data.host,
        })
        resolve(data.host)
      } else {
        yield put({
          type: SUPERVISOR_ADD_HOST_FAILURE,
          error: general_errors,
        })
        reject({ general_errors, form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({ type: SUPERVISOR_ADD_HOST_FAILURE, error })
    }
  }
}

export function* supervisorRemoveHost() {
  while (true) {
    const { resolve, reject, hostId } = yield take(SUPERVISOR_REMOVE_HOST_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.supervisorRemoveHost, hostId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SUPERVISOR_REMOVE_HOST_SUCCESS,
        })
        resolve(data)
      } else {
        yield put({
          type: SUPERVISOR_REMOVE_HOST_FAILURE,
          error: general_errors,
        })
        reject({ general_errors, form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({ type: SUPERVISOR_REMOVE_HOST_FAILURE, error })
    }
  }
}


export function* editSupervisorHost() {
  while (true) {
    const { resolve, reject, hostId, formData } = yield take(EDIT_SUPERVISOR_HOST_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.editSupervisorHost, hostId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: EDIT_SUPERVISOR_HOST_SUCCESS,
          host: data.host,
        })
        resolve(data.host)
      } else {
        yield put({
          type: EDIT_SUPERVISOR_HOST_FAILURE,
          error: general_errors,
        })
        reject({ general_errors, form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({ type: EDIT_SUPERVISOR_HOST_FAILURE, error })
    }
  }
}

export function* addStudentsToSupervisorHost() {
  while (true) {
    const {
      resolve,
      reject,
      hostId,
      formData
    } = yield take(ADD_STUDENTS_TO_SUPERVISOR_HOST_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.addStudentsToSupervisorHost, hostId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: ADD_STUDENTS_TO_SUPERVISOR_HOST_SUCCESS,
          host: data.host,
        })
        resolve(data.host)
      } else {
        yield put({
          type: ADD_STUDENTS_TO_SUPERVISOR_HOST_FAILURE,
          error: general_errors,
        })
        reject({ general_errors, form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({ type: ADD_STUDENTS_TO_SUPERVISOR_HOST_FAILURE, error })
    }
  }
}

export function* removeStudentsFromSupervisorHost() {
  while (true) {
    const {
      resolve,
      reject,
      hostId,
      formData
    } = yield take(REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.removeStudentsFromSupervisorHost, hostId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_SUCCESS,
          host: data.host,
        })
        resolve(data.host)
      } else {
        yield put({
          type: REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_FAILURE,
          error: general_errors,
        })
        reject({ general_errors, form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({ type: REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_FAILURE, error })
    }
  }
}

export function* supervisorAddPromoCode() {
  while (true) {
    const { resolve, reject, formData } = yield take(SUPERVISOR_ADD_PROMO_CODE_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.addPromoCode, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SUPERVISOR_ADD_PROMO_CODE_SUCCESS,
          data,
        })
        resolve(data)
      } else {
        yield put({
          type: SUPERVISOR_ADD_PROMO_CODE_FAILURE,
          error: general_errors,
        })
        reject({ general_errors, form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({ type: SUPERVISOR_ADD_PROMO_CODE_FAILURE, error })
    }
  }
}

export function* supervisorUpdatePromoCode() {
  while (true) {
    const { resolve, reject, promoId, formData } = yield take(SUPERVISOR_UPDATE_PROMO_CODE_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.updatePromoCode, promoId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SUPERVISOR_UPDATE_PROMO_CODE_SUCCESS,
          data,
        })
        resolve(data)
      } else {
        yield put({
          type: SUPERVISOR_UPDATE_PROMO_CODE_FAILURE,
          error: general_errors,
        })
        reject({ general_errors, form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({ type: SUPERVISOR_UPDATE_PROMO_CODE_FAILURE, error })
      reject(error)
    }
  }
}

export function* supervisorFetchEventPromoCodes() {
  while (true) {
    const {
      eventId,
    } = yield take(SUPERVISOR_FETCH_PROMO_CODES_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.fetchPromoCodes, eventId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SUPERVISOR_FETCH_PROMO_CODES_SUCCESS,
          data,
        })
      } else {
        yield put({
          type: SUPERVISOR_FETCH_PROMO_CODES_FAILURE,
          error: general_errors,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SUPERVISOR_HOST_FAILURE,
        error,
      })
    }
  }
}

export function* supervisorFetchSinglePromoCode() {
  while (true) {
    const {
      promoId,
    } = yield take(FETCH_SINGLE_PROMO_CODE_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors },
        },
      } = yield call(api.fetchSinglePromoCode, promoId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SINGLE_PROMO_CODE_SUCCESS,
          promo_code: data.promo_code,
        })
      } else {
        yield put({
          type: FETCH_SINGLE_PROMO_CODE_FAILURE,
          error: general_errors,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: FETCH_SINGLE_PROMO_CODE_FAILURE,
        error,
      })
    }
  }
}

export function* supervisorFetchEventDocuments() {
  while (true) {
    const {
      eventId,
    } = yield take(SUPERVISOR_FETCH_EVENT_DOCUMENTS_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors},
        },
      } = yield call(api.supervisorFetchEventDocuments, eventId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SUPERVISOR_FETCH_EVENT_DOCUMENTS_SUCCESS,
          ticket: data.ticket,
        })
      } else {
        yield put({
          type: SUPERVISOR_FETCH_EVENT_DOCUMENTS_FAILURE,
          error: general_errors,
        })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: SUPERVISOR_FETCH_EVENT_DOCUMENTS_FAILURE,
        error,
      })
    }
  }
}

export function* supervisorFinishEvnetHostingSetup() {
  while (true) {
    const {
      eventId,
      resolve,
      reject,
    } = yield take(SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_REQUEST)

    try {
      const {
        data: {
          status,
          data,
          errors: { general_errors, form_errors},
        },
      } = yield call(api.supervisorFinishEventHosting, eventId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_SUCCESS,
          data,
        })

        resolve(data)

      } else {
        yield put({
          type: SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_FAILURE,
          error: { general_errors, form_errors },
        })

        reject({ ...general_errors, ...form_errors })
      }

    } catch (error) {
      console.log(error)
      yield put({
        type: SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_FAILURE,
        error,
      })
      reject(error)
    }
  }
}


// WEBPACK FOOTER //
// ./src/sagas/supervisorsSaga.js